import type React from "react"

import { RecommendedActions } from "../../actions/recommended-actions"
import { VirtualSubmeteringHeader } from "../../virtual-submetering-header"

export const RecommendedActionsRoute: React.FC = () => (
  <>
    <VirtualSubmeteringHeader />
    <RecommendedActions />
  </>
)
